import React, { Component } from 'react';
import http from '../modules/api';

import SelectBoxV2 from '../modules/common/SelectBoxV2';
import SaveDialogV2 from '../modules/dialogs/SaveDialogV2';
import WarningDialog from '../modules/dialogs/WarningDialog';

const params = new URLSearchParams(window.location.search);

const CATEGORY_DEPTH_1_LIST = [
  { category_no: '1000', category_name: '여성의류' },
];

const CATEGORY_DEPTH_2_LIST = [
  { category_no: '1100', parent_category_no: '1000', category_name: '상의' },
  { category_no: '1200', parent_category_no: '1000', category_name: '아우터' },
  { category_no: '1300', parent_category_no: '1000', category_name: '하의' },
];

const CATEGORY_DEPTH_3_LIST = [
  { category_no: '1110', parent_category_no: '1100', category_name: '티셔츠' },
  { category_no: '1210', parent_category_no: '1200', category_name: '자켓' },
  { category_no: '1310', parent_category_no: '1300', category_name: '팬츠' },
];

const CATEGORY_DEPTH_4_LIST = [
  { category_no: '100', parent_category_no: '1110', category_name: '반팔티' },
  { category_no: '205', parent_category_no: '1210', category_name: '블레이저' },
  { category_no: '310', parent_category_no: '1310', category_name: '데님' },
];

const ICON_OPTION_LIST = [
  { icon_cd: 'NEW', icon_name: 'NEW' },
  { icon_cd: 'BEST', icon_name: 'BEST' },
  { icon_cd: 'HOT', icon_name: 'HOT' },
];

const PRODUCT_ICON_LIST = [
  {
    code: "custom_12",
    path: "https://ecimg.cafe24img.com/pg1512b73653014091/cherrycrko/web/upload/custom_1217461802208969.png"
  },
  {
    code: "custom_9",
    path: "https://ecimg.cafe24img.com/pg1512b73653014091/cherrycrko/web/upload/custom_917461730962271.png"
  },
  {
    code: "custom_11",
    path: "https://ecimg.cafe24img.com/pg1512b73653014091/cherrycrko/web/upload/custom_1117461800973453.png"
  },
  {
    code: "custom_13",
    path: "https://ecimg.cafe24img.com/pg1512b73653014091/cherrycrko/web/upload/custom_1317772591117657.png"
  }
];

class ProductSetting_category_icon_added extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shop_name: '',
      isAutoHideSoldOutOn: false,
      isCategoryIconAutoOn: false,

      category_depth_1_no: '',
      category_depth_2_no: '',
      category_depth_3_no: '',
      category_depth_4_no: '',

      product_category_list_1: [],
      product_category_list_2: [],
      product_category_list_3: [],
      product_category_list_4: [],

      category_icon_setting_list: [],

      save_dialog_show_state: false,
      save_dialog_content: '',
      save_dialog_button_list: [],

      product_icon_list: [],
    };
  }

  componentDidMount() {
    this.loadProductIcons();
    this.loadProductSetting();
    this.loadCategoryIconSettingList();
    this.loadProductCategory('', 1);
  }

  openSaveDialog = (content) => {
    this.setState({
      save_dialog_show_state: true,
      save_dialog_content: content,
      save_dialog_button_list: [
        {
          title: '확인',
          event_method: () => this.setState({ save_dialog_show_state: false }),
        },
      ],
    });
  };
  openWarningDialog = (content) => {
    this.setState({
      warning_dialog_show_state: true,
      warning_dialog_content: content,
      warning_dialog_button_list: [
        {
          title: '확인',
          event_method: () => this.setState({ warning_dialog_show_state: false }),
        },
      ],
    });
  };

  getShopNo = () => {
    return params.get('shop_no') || this.props?.shop_no || '';
  };

  saveProductSetting = (nextState = {}) => {
    const isAutoHideSoldOutOn = nextState.isAutoHideSoldOutOn !== undefined
      ? nextState.isAutoHideSoldOutOn
      : this.state.isAutoHideSoldOutOn;

    const isCategoryIconAutoOn = nextState.isCategoryIconAutoOn !== undefined
      ? nextState.isCategoryIconAutoOn
      : this.state.isCategoryIconAutoOn;

    return http.post('/rest/shop/product-setting/save', {
      shop_no: this.getShopNo(),
      auto_hide_sold_out_yn: isAutoHideSoldOutOn ? 'Y' : 'N',
      category_icon_auto_yn: isCategoryIconAutoOn ? 'Y' : 'N',
    });
  };

  toggleAutoHideSoldOut = () => {
    this.setState((prevState) => ({
      isAutoHideSoldOutOn: !prevState.isAutoHideSoldOutOn,
    }), () => {
      this.saveProductSetting()
        .then((response) => {
          const result = response?.data;
          if (result?.result !== 'success') {
            this.openWarningDialog(result?.message || '저장에 실패했습니다.');
          }
        })
        .catch((error) => {
          console.error('품절 자동 미진열 저장 중 오류 발생:', error);
          this.openWarningDialog('품절 자동 미진열 설정 저장 중 오류가 발생했습니다.');
        });
    });
  };

  toggleCategoryIconAuto = () => {
    this.setState((prevState) => ({
      isCategoryIconAutoOn: !prevState.isCategoryIconAutoOn,
    }), () => {
      this.saveProductSetting()
        .then((response) => {
          const result = response?.data;
          if (result?.result !== 'success') {
            this.openWarningDialog(result?.message || '저장에 실패했습니다.');
          }
        })
        .catch((error) => {
          console.error('카테고리별 상품 아이콘 자동 설정 저장 중 오류 발생:', error);
          this.openWarningDialog('카테고리별 상품 아이콘 자동 설정 저장 중 오류가 발생했습니다.');
        });
    });
  };

  loadProductCategory = (parentCategory, depth) => {
    const sendForm = {
      parent_category_no: parentCategory || '',
    };

    const name = `product_category_list_${depth}`;

    http.get('/rest/common/cafe24/category', { params: sendForm })
      .then((res) => {
        this.setState({
          [name]: res?.data?.list || [],
        });
      })
      .catch((error) => {
        console.log('===== error =====');
        console.log(error);
        console.log('===== error request =====');
        console.log(error.request);
      });
  };

  loadProductSetting = () => {
    http.get('/rest/shop/product-setting', {
      params: {
        shop_no: this.getShopNo(),
      },
    })
      .then((response) => {
        const result = response?.data;

        if (result?.result === 'success') {
          this.setState({
            shop_name: result.shop_name || '',
            isAutoHideSoldOutOn: result.data?.auto_hide_sold_out_yn === 'Y',
            isCategoryIconAutoOn: result.data?.category_icon_auto_yn === 'Y',
          });
        }
      })
      .catch((error) => {
        console.error('설정 조회 중 오류 발생:', error);
      });
  };

  loadCategoryIconSettingList = () => {
    http.get('/rest/shop/productCategoryIconSetting/list', {
      params: {
        shop_no: this.getShopNo(),
      },
    })
      .then((response) => {
        const result = response?.data;

        if (result?.result === 'success') {
          this.setState({
            category_icon_setting_list: result.category_icon_setting_list || [],
          });
        }
      })
      .catch((error) => {
        console.error('카테고리별 상품 아이콘 자동 설정 조회 중 오류 발생:', error);
      });
  };

  saveCategoryIconSettingList = (categoryIconSettingList = this.state.category_icon_setting_list) => {
    return http.post('/rest/shop/productCategoryIconSetting/save', {
      shop_no: this.getShopNo(),
      category_icon_setting_list: categoryIconSettingList,
    })
      .then((response) => {
        const result = response?.data;
        if (result?.result !== 'success') {
          this.openWarningDialog(result?.message || '카테고리별 상품 아이콘 자동 설정 저장에 실패했습니다.');
          return;
        }
        this.loadCategoryIconSettingList();
      })
      .catch((error) => {
        console.error('카테고리별 상품 아이콘 자동 설정 저장 중 오류 발생:', error);
        this.openWarningDialog('카테고리별 상품 아이콘 자동 설정 저장 중 오류가 발생했습니다.');
      });
  };

  onChangeCategoryDepth = (depth, value) => {
    const nextState = {};

    if (depth === 1) {
      nextState.category_depth_1_no = value;
      nextState.category_depth_2_no = '';
      nextState.category_depth_3_no = '';
      nextState.category_depth_4_no = '';
      nextState.product_category_list_2 = [];
      nextState.product_category_list_3 = [];
      nextState.product_category_list_4 = [];
    }

    if (depth === 2) {
      nextState.category_depth_2_no = value;
      nextState.category_depth_3_no = '';
      nextState.category_depth_4_no = '';
      nextState.product_category_list_3 = [];
      nextState.product_category_list_4 = [];
    }

    if (depth === 3) {
      nextState.category_depth_3_no = value;
      nextState.category_depth_4_no = '';
      nextState.product_category_list_4 = [];
    }

    if (depth === 4) {
      nextState.category_depth_4_no = value;
    }

    this.setState(nextState, () => {
      if (value && depth < 4) {
        this.loadProductCategory(value, depth + 1);
      }
    });
  };

  getCategoryName = (categoryObj) => {
    if (!categoryObj) return '';
    return categoryObj.category_name || categoryObj.name || categoryObj.categoryName || '';
  };

  getSelectedCategoryInfo = () => {
    const {
      category_depth_1_no,
      category_depth_2_no,
      category_depth_3_no,
      category_depth_4_no,
      product_category_list_1,
      product_category_list_2,
      product_category_list_3,
      product_category_list_4,
    } = this.state;

    const depth1 = product_category_list_1.find((obj) => String(obj.category_no) === String(category_depth_1_no));
    const depth2 = product_category_list_2.find((obj) => String(obj.category_no) === String(category_depth_2_no));
    const depth3 = product_category_list_3.find((obj) => String(obj.category_no) === String(category_depth_3_no));
    const depth4 = product_category_list_4.find((obj) => String(obj.category_no) === String(category_depth_4_no));

    if (!depth1 || !depth2 || !depth3 || !depth4) {
      return null;
    }

    return {
      category_no: depth4.category_no,
      category_path: `${this.getCategoryName(depth1)} > ${this.getCategoryName(depth2)} > ${this.getCategoryName(depth3)} > ${this.getCategoryName(depth4)}`,
    };
  };

  addCategoryIconSetting = () => {
    const { product_icon_list } = this.state;
    const selectedCategory = this.getSelectedCategoryInfo();

    if (!selectedCategory) {
      this.openWarningDialog('카테고리를 선택해 주세요.');
      return;
    }

    const { category_icon_setting_list } = this.state;

    const isExists = (category_icon_setting_list || []).some((item) => (
      String(item.category_no) === String(selectedCategory.category_no)
    ));

    if (isExists) {
      this.openWarningDialog('이미 추가된 카테고리입니다.');
      return;
    }

    const nextList = [
      ...(category_icon_setting_list || []),
      {
        category_no: selectedCategory.category_no,
        category_path: selectedCategory.category_path,
        icon_cd: product_icon_list[0].code, // 기본값으로 첫 번째 아이콘 설정
        auto_add_yn: 'Y',
        auto_remove_yn: 'Y',
      },
    ];

    this.setState({ category_icon_setting_list: nextList }, () => {
      this.saveCategoryIconSettingList(nextList);
    });
  };

  getSelectedCategoryInfo = () => {
    const {
      category_depth_1_no,
      category_depth_2_no,
      category_depth_3_no,
      category_depth_4_no,
      product_category_list_1,
      product_category_list_2,
      product_category_list_3,
      product_category_list_4,
    } = this.state;

    const depth1 = product_category_list_1.find((obj) => String(obj.category_no) === String(category_depth_1_no));
    const depth2 = product_category_list_2.find((obj) => String(obj.category_no) === String(category_depth_2_no));
    const depth3 = product_category_list_3.find((obj) => String(obj.category_no) === String(category_depth_3_no));
    const depth4 = product_category_list_4.find((obj) => String(obj.category_no) === String(category_depth_4_no));

    const selectedDepthList = [];

    if (depth1) selectedDepthList.push(depth1);
    if (depth2) selectedDepthList.push(depth2);
    if (depth3) selectedDepthList.push(depth3);
    if (depth4) selectedDepthList.push(depth4);

    if (selectedDepthList.length === 0) {
      return null;
    }

    const lastSelectedCategory = selectedDepthList[selectedDepthList.length - 1];

    return {
      category_no: lastSelectedCategory.category_no,
      category_path: selectedDepthList.map((obj) => this.getCategoryName(obj)).join(' > '),
    };
  };

  updateCategoryIconSetting = (index, key, value) => {
    const nextList = this.state.category_icon_setting_list.map((item, itemIndex) => {
      if (itemIndex !== index) return item;
      return {
        ...item,
        [key]: value,
      };
    });

    this.setState({ category_icon_setting_list: nextList }, () => {
      this.saveCategoryIconSettingList(nextList);
    });
  };

  deleteCategoryIconSetting = (index) => {
    const nextList = this.state.category_icon_setting_list.filter((item, itemIndex) => itemIndex !== index);

    this.setState({ category_icon_setting_list: nextList }, () => {
      this.saveCategoryIconSettingList(nextList);
    });
  };

  renderToggleSwitch = (isOn) => (
    <div className={`toggle-switch ${isOn ? 'on' : ''}`}>
      <div className="toggle-knob"></div>
    </div>
  );

  renderYnToggle = (value, onClick) => {
    const isOn = value === 'Y';

    return (
      <button type="button" className="yn-toggle-wrap" onClick={onClick}>
        <span className={`mini-toggle ${isOn ? 'on' : ''}`}>
          <span className="mini-toggle-knob"></span>
        </span>
        {/* <span className="yn-text">{isOn ? 'Y' : 'N'}</span> */}
      </button>
    );
  };

  renderIconBadge = (iconCd) => {
    return <span className={`icon-badge icon-${String(iconCd).toLowerCase()}`}>{iconCd}</span>;
  };

  renderCategorySelect = (depth, selectedValue, list, disabled) => {
    return (
      <SelectBoxV2
        id={`category_depth_${depth}_select`}
        className="category-select-box"
        pageWrapperName="page-wrapper"
        width="100%"
        height="42px"
        padding="0 36px 0 12px"
        list={list || []}
        optionTexttName="category_name_no_format"
        optionValuetName="category_no"
        selectedValue={selectedValue}
        placeHolder={`${depth}뎁스 선택`}
        disabled={disabled}
        disabledColor="#f7f7f7"
        selectAreaMaxHeight="260px"
        boundingSelector="#page-wrapper"
        onClickOption={(text, value) => this.onChangeCategoryDepth(depth, value)}
      />
    );
  };

  renderIconSelect = (item, index) => {
    const { product_icon_list } = this.state;
    return (
      product_icon_list && product_icon_list.length > 0
      ? <SelectBoxV2
        id={`category_icon_select_${index}`}
        className="category-icon-select-box"
        pageWrapperName="page-wrapper"
        width="96px"
        height="34px"
        padding="0 28px 0 10px"
        list={product_icon_list}
        optionTexttName="code"
        optionValuetName="code"
        optionImageName="path"
        selectedValue={item.icon_cd}
        placeHolder="아이콘"
        usePortal={true}
        portalScrollCloseSelector=".category-icon-table-wrap"
        onClickOption={(text, value) => this.changeCategoryIconSetting(index, "icon_cd", value)}
      />
      : <SelectBoxV2
        id={`category_icon_select_${index}`}
        className="category-icon-select-box"
        pageWrapperName="page-wrapper"
        width="96px"
        height="34px"
        padding="0 28px 0 10px"
        list={[]}
        optionValuetName="code"
        optionImageName="path"
        selectedValue={""}
        placeHolder="아이콘"
        usePortal={true}
        portalScrollCloseSelector=".category-icon-table-wrap"
        onClickOption={(text, value) => this.changeCategoryIconSetting(index, "icon_cd", value)}
      />
    );
  };

  changeCategoryIconSetting = (index, key, value) => {
    this.setState((prevState) => {
      const nextList = (prevState.category_icon_setting_list || []).map((item, itemIndex) => {
        if (itemIndex !== index) {
          return item;
        }

        return {
          ...item,
          [key]: value,
        };
      });

      return {
        category_icon_setting_list: nextList,
      };
    }, () => {
      this.saveCategoryIconSettingList(this.state.category_icon_setting_list);
    });
  };

  loadProductIcons = () => {
    http.get('/rest/shop/product/icons')
      .then((response) => {
        const result = response?.data;

        if (result.icons) {
          this.setState({
            product_icon_list: result.icons
          });
        }
      })
      .catch((error) => {
        console.error('설정 조회 중 오류 발생:', error);
      });
  };

  render() {
    const {
      shop_name,
      isAutoHideSoldOutOn,
      isCategoryIconAutoOn,
      category_depth_1_no,
      category_depth_2_no,
      category_depth_3_no,
      category_depth_4_no,
      product_category_list_1,
      product_category_list_2,
      product_category_list_3,
      product_category_list_4,
      category_icon_setting_list,
    } = this.state;

    const depth1List = product_category_list_1 || [];
    const depth2List = product_category_list_2 || [];
    const depth3List = product_category_list_3 || [];
    const depth4List = product_category_list_4 || [];

    return (
      <>
        <div className="main-wrapper robo-md-product-setting-setting-page" id="page-wrapper" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#f3f4f6', fontFamily: "'Noto Sans KR', sans-serif" }}>
          <div className="robo-md-product-setting">
            <style>{`
              .robo-md-product-setting-setting-page {
                --primary-mint: #00e2e6;
                --primary-mint-hover: #00bfc2;
                --deep-navy: #0A1A2F;
                --border-color: #e5e7eb;
                --text-main: #0A1A2F;
                --text-sub: #6b7280;
                --white: #ffffff;
              }

              .robo-md-product-setting-setting-page { padding-top: 72px !important; max-width: 100% !important; }
              .robo-md-product-setting * { margin: 0; padding: 0; box-sizing: border-box; font-family: 'Noto Sans KR', sans-serif; }
              .robo-md-product-setting { background-color: #f9fafb; color: #0A1A2F; line-height: 1.6; min-height: 100%; }
              .robo-md-product-setting .main-content { padding: 40px; max-width: 1024px; margin: 0 auto; width: 100%; }
              .robo-md-product-setting .page-header { margin-bottom: 24px; }
              .robo-md-product-setting .page-title { font-size: 28px; font-weight: 700; margin-bottom: 8px; color: #0A1A2F; }
              .robo-md-product-setting .page-subtitle { font-size: 15px; color: #6b7280; }
              .robo-md-product-setting .card { background: white; border: 1px solid #e5e7eb; border-radius: 12px; padding: 32px; margin-bottom: 24px; box-shadow: 0 2px 8px rgba(10, 26, 47, 0.02); }
              .robo-md-product-setting .card-title { font-size: 18px; font-weight: 700; margin-bottom: 8px; color: #0A1A2F; }
              .robo-md-product-setting .card-desc { font-size: 14px; color: #6b7280; margin-bottom: 24px; border-bottom: 2px solid #f9fafb; padding-bottom: 16px; }

              .robo-md-product-setting .toggle-row { display: flex; flex-direction: column; padding: 20px; background: #f9fafb; border-radius: 8px; margin-bottom: 16px; border: 1px solid #e5e7eb; transition: all 0.3s; }
              .robo-md-product-setting .toggle-row.active { background: white; border-color: #00e2e6; box-shadow: 0 2px 8px rgba(0, 226, 230, 0.1); }
              .robo-md-product-setting .toggle-header { display: flex; justify-content: space-between; align-items: center; width: 100%; gap: 16px; cursor: pointer; }
              .robo-md-product-setting .toggle-info { flex: 1; }
              .robo-md-product-setting .toggle-info strong { display: block; font-size: 15px; color: #0A1A2F; margin-bottom: 4px; }
              .robo-md-product-setting .toggle-info span { font-size: 13px; color: #6b7280; display: block; line-height: 1.4; }
              .robo-md-product-setting .toggle-switch { position: relative; width: 52px; height: 28px; background: #d1d5db; border-radius: 14px; transition: all 0.3s; flex-shrink: 0; }
              .robo-md-product-setting .toggle-switch.on { background: #00e2e6; }
              .robo-md-product-setting .toggle-knob { position: absolute; top: 3px; left: 3px; width: 22px; height: 22px; background: white; border-radius: 50%; transition: all 0.3s; box-shadow: 0 2px 4px rgba(0,0,0,0.1); }
              .robo-md-product-setting .toggle-switch.on .toggle-knob { left: auto; right: 3px; }
              .robo-md-product-setting .expandable-content { display: none; padding-top: 20px; margin-top: 20px; border-top: 1px dashed #e5e7eb; width: 100%; animation: fadeIn 0.3s ease; }
              .robo-md-product-setting .toggle-row.active .expandable-content { display: block; }

              .robo-md-product-setting .category-icon-panel { background: #f9fafb; border: 1px solid #dbe2ea; border-radius: 10px; padding: 20px; }
              .robo-md-product-setting .category-icon-title { font-size: 15px; font-weight: 700; color: #0A1A2F; margin-bottom: 4px; }
              .robo-md-product-setting .category-icon-desc { font-size: 13px; color: #6b7280; margin-bottom: 18px; }
              .robo-md-product-setting .category-select-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 14px; align-items: end; margin-bottom: 14px; }
              .robo-md-product-setting .category-select-label { display: block; font-size: 13px; font-weight: 600; color: #4b5563; margin-bottom: 6px; }
              .robo-md-product-setting .category-select { width: 100%; height: 42px; padding: 0 12px; border: 1px solid #d1d5db; border-radius: 8px; background: #fff; color: #0A1A2F; font-size: 14px; outline: none; }
              .robo-md-product-setting .category-select:focus { border-color: #00e2e6; box-shadow: 0 0 0 3px rgba(0, 226, 230, 0.1); }
              .robo-md-product-setting .category-add-row { display: flex; justify-content: flex-end; margin-bottom: 14px; }
              .robo-md-product-setting .category-add-btn { height: 38px; padding: 0 16px; border-radius: 8px; border: 1px solid #00bfc2; background: #fff; color: #00a9ad; font-weight: 700; cursor: pointer; }
              .robo-md-product-setting .category-add-btn:hover { background: rgba(0, 226, 230, 0.06); }

              .robo-md-product-setting .category-icon-table-wrap { overflow-x: auto; background: #fff; border: 1px solid #e5e7eb; border-radius: 10px; }
              .robo-md-product-setting .category-icon-table { width: 100%; border-collapse: collapse; min-width: 720px; }
              .robo-md-product-setting .category-icon-table th { height: 42px; padding: 10px 14px; background: #f9fafb; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-size: 13px; font-weight: 700; text-align: center; }
              .robo-md-product-setting .category-icon-table th:first-child { text-align: left; }
              .robo-md-product-setting .category-icon-table td { padding: 12px 14px; border-bottom: 1px solid #e5e7eb; vertical-align: middle; font-size: 13px; color: #0A1A2F; }
              .robo-md-product-setting .category-icon-table tr:last-child td { border-bottom: none; }
              .robo-md-product-setting .category-path { font-weight: 600; color: #0A1A2F; text-align: left; }
              .robo-md-product-setting .category-no { color: #6b7280; margin-top: 2px; text-align: left; }
              .robo-md-product-setting .icon-select-wrap { display: flex; align-items: center; justify-content: center; gap: 6px; }
              .robo-md-product-setting .icon-select { height: 36px; min-width: 98px; padding: 0 8px; border: 1px solid #d1d5db; border-radius: 8px; background: #fff; color: #0A1A2F; outline: none; }
              .robo-md-product-setting .icon-badge { display: inline-flex; align-items: center; justify-content: center; height: 28px; min-width: 54px; padding: 0 10px; border-radius: 7px; font-weight: 700; font-size: 13px; background: #ecfeff; color: #00a9ad; border: 1px solid #99f6e4; }
              .robo-md-product-setting .icon-new { background: #ecfdf5; color: #10b981; border-color: #86efac; }
              .robo-md-product-setting .icon-best { background: #eff6ff; color: #2563eb; border-color: #93c5fd; }
              .robo-md-product-setting .icon-hot { background: #fff1f2; color: #ef4444; border-color: #fda4af; }
              .robo-md-product-setting .yn-toggle-wrap { display: inline-flex; align-items: center; justify-content: center; gap: 8px; border: none; background: transparent; cursor: pointer; }
              .robo-md-product-setting .mini-toggle { position: relative; display: inline-block; width: 42px; height: 24px; background: #d1d5db; border-radius: 12px; transition: all 0.2s; }
              .robo-md-product-setting .mini-toggle.on { background: #00e2e6; }
              .robo-md-product-setting .mini-toggle-knob { position: absolute; top: 3px; left: 3px; width: 18px; height: 18px; background: #fff; border-radius: 50%; box-shadow: 0 1px 3px rgba(0,0,0,0.15); transition: all 0.2s; }
              .robo-md-product-setting .mini-toggle.on .mini-toggle-knob { left: 21px; }
              .robo-md-product-setting .yn-text { min-width: 12px; color: #4b5563; font-weight: 700; font-size: 13px; }
              .robo-md-product-setting .row-delete-btn { width: 34px; height: 34px; border: 1px solid #d1d5db; border-radius: 8px; background: #fff; color: #4b5563; cursor: pointer; font-size: 16px; }
              .robo-md-product-setting .row-delete-btn:hover { background: #fee2e2; border-color: #fecaca; color: #dc2626; }
              .robo-md-product-setting .empty-row { padding: 22px !important; text-align: center !important; color: #9ca3af !important; }

              .robo-md-product-setting .btn-outline {
                  height: 38px; padding: 0 16px; border-radius: 8px;
                  font-size: 13px;
                  font-weight: 700; cursor: pointer;
                  background: var(--white);
                  border: 1px solid #cbd5e1;
                  color: var(--text-main);
              }
              .robo-md-product-setting .btn-outline:hover {
                background: var(--bg-color);
                border-color: var(--deep-navy);
              }
                
              .robo-md-product-setting .category-select-box.select_able {
                  background-color: #FFF !important;
                  font-weight: 500 !important;
              }


              @keyframes fadeIn { from { opacity: 0; transform: translateY(-5px); } to { opacity: 1; transform: translateY(0); } }
              @media (max-width: 800px) {
                .robo-md-product-setting .main-content { padding: 24px 16px; }
                .robo-md-product-setting .card { padding: 24px 20px; }
                .robo-md-product-setting .category-select-grid { grid-template-columns: 1fr; }
              }
            `}</style>

            <main className="main-content">
              <div className="page-header">
                <h1 className="page-title">상품 환경 설정</h1>
                <p className="page-subtitle">상품 운영에 필요한 자동 처리 옵션을 설정합니다. {shop_name ? `(${shop_name})` : ''}</p>
              </div>

              <div className="card">
                <div className="card-title">상품 자동 처리 설정</div>
                <p className="card-desc">상품 상태 변경 시 자동으로 처리할 동작을 설정합니다.</p>

                <div className={`toggle-row ${isAutoHideSoldOutOn ? 'active' : ''}`} id="toggle-auto-hide-sold-out">
                  <div className="toggle-header" onClick={this.toggleAutoHideSoldOut}>
                    <div className="toggle-info">
                      <strong>품절 시 자동 미진열</strong>
                      <span>이 기능을 켜면 앞으로 품절이 발생한 상품을 자동으로 미진열 처리합니다.</span>
                    </div>
                    {this.renderToggleSwitch(isAutoHideSoldOutOn)}
                  </div>
                </div>

                <div className={`toggle-row ${isCategoryIconAutoOn ? 'active' : ''}`} id="toggle-category-icon-auto">
                  <div className="toggle-header" onClick={this.toggleCategoryIconAuto}>
                    <div className="toggle-info">
                      <strong>카테고리별 상품 아이콘 자동 설정</strong>
                      <span>카테고리에 상품이 추가되거나 제거될 때 설정된 아이콘을 자동으로 관리합니다.</span>
                    </div>
                    {this.renderToggleSwitch(isCategoryIconAutoOn)}
                  </div>

                  <div className="expandable-content" onClick={(e) => e.stopPropagation()}>
                    <div className="category-icon-panel">
                      <div className="category-icon-title">카테고리별 아이콘 설정</div>
                      <div className="category-icon-desc">카테고리별 아이콘의 자동 추가/제거 여부를 설정할 수 있습니다.</div>

                      <div className="category-select-grid">
                        <div>
                          <label className="category-select-label">1뎁스</label>
                          {this.renderCategorySelect(1, category_depth_1_no, depth1List, false)}
                        </div>

                        <div>
                          <label className="category-select-label">2뎁스</label>
                          {this.renderCategorySelect(2, category_depth_2_no, depth2List, !category_depth_1_no)}
                        </div>

                        <div>
                          <label className="category-select-label">3뎁스</label>
                          {this.renderCategorySelect(3, category_depth_3_no, depth3List, !category_depth_2_no)}
                        </div>

                        <div>
                          <label className="category-select-label">4뎁스</label>
                          {this.renderCategorySelect(4, category_depth_4_no, depth4List, !category_depth_3_no)}
                        </div>
                      </div>

                      <div className="category-add-row">
                        <button type="button" className="btn btn-outline" onClick={this.addCategoryIconSetting}>＋ 카테고리 추가</button>
                      </div>

                      <div className="category-icon-table-wrap">
                        <table className="category-icon-table">
                          <thead>
                            <tr>
                              <th>카테고리</th>
                              <th>아이콘</th>
                              <th>자동 추가</th>
                              <th>자동 제거</th>
                              <th>관리</th>
                            </tr>
                          </thead>
                          <tbody>
                            {category_icon_setting_list.length === 0 && (
                              <tr>
                                <td className="empty-row" colSpan="5">추가된 카테고리가 없습니다.</td>
                              </tr>
                            )}

                            {category_icon_setting_list.map((item, index) => (
                              <tr key={`${item.category_no}_${index}`}>
                                <td>
                                  <div className="category-path">{item.category_path}</div>
                                  <div className="category-no">카테고리 {item.category_no}번</div>
                                </td>
                                <td>
                                  <div className="icon-select-wrap">
                                    {/* {this.renderIconBadge(item.icon_cd)} */}
                                    {this.renderIconSelect(item, index)}
                                  </div>
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                  {this.renderYnToggle(item.auto_add_yn, () => this.updateCategoryIconSetting(index, 'auto_add_yn', item.auto_add_yn === 'Y' ? 'N' : 'Y'))}
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                  {this.renderYnToggle(item.auto_remove_yn, () => this.updateCategoryIconSetting(index, 'auto_remove_yn', item.auto_remove_yn === 'Y' ? 'N' : 'Y'))}
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                  <button type="button" className="row-delete-btn" onClick={() => this.deleteCategoryIconSetting(index)}>🗑</button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className="category-icon-desc" style={{ marginTop: '12px', marginBottom: '-3px' }}>
                      ※ 자동 추가: 카테고리 변경이 감지된 상품이 ‘자동 추가’ 카테고리에 속해 있으면 아이콘을 추가합니다.<br/>
                      ※ 자동 제거: 카테고리 변경이 감지된 상품이 ‘자동 제거’ 카테고리에 더 이상 속해 있지 않으면 아이콘을 제거합니다.<br/>
                      ※ 동일한 아이콘에 대해 ‘자동 추가’와 ‘자동 제거’ 조건이 모두 해당되는 상품은, ‘자동 추가’ 카테고리에 하나라도 속해 있으면 해당 아이콘을 제거하지 않습니다. (아이콘이 아직 등록되어 있지 않은 경우에는 자동으로 추가됩니다.)
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>

        {this.state.save_dialog_show_state === true &&
          <SaveDialogV2
            content={this.state.save_dialog_content}
            button_list={this.state.save_dialog_button_list}
          />
        }
        {this.state.warning_dialog_show_state === true &&
          <WarningDialog
            content={this.state.warning_dialog_content}
            button_list={this.state.warning_dialog_button_list}
            popup_close={() => this.setState({ warning_dialog_show_state: false })}
          />
        }
      </>
    );
  }
}

export default ProductSetting_category_icon_added;
